import { vars } from '@croquiscom-pvt/zds/dist/tokens';
import styled from '@emotion/styled';

export const Summary = ({ children }: { children: React.ReactNode }) => {
  return <Container>{children}</Container>;
};

const Container = styled.div`
  margin: 0 0 10px 0;
  padding: 0 0 12px 0;
  border-bottom: 1px solid ${vars.v3Color.gray100};
`;
